export default __webpack_public_path__ + "static/media/off.c77f1888.mp3";